@let c = card();

<article class="nodal-line-card" [style.--line-color]="c.color">
  <header class="nodal-line-card__header">
    <div class="nodal-line-card__header-left">
      <p class="nodal-line-card__kicker">{{ c.kicker }}</p>
      <h3 class="nodal-line-card__name">{{ c.name }}</h3>
    </div>
    <div class="nodal-line-card__header-right">
      <span class="nodal-line-card__number">{{ line() }}</span>
      <span class="nodal-line-card__keyword">{{ c.keyword }}</span>
      <span class="nodal-line-card__keyword2">{{ c.keyword2 }}</span>
    </div>
  </header>
  <p class="nodal-line-card__subtitle">{{ c.subtitle }}</p>
  <ul class="nodal-line-card__bullets">
    @for (bullet of c.bullets; track $index) {
      <li>{{ bullet }}</li>
    }
  </ul>
  <footer class="nodal-line-card__meta">{{ c.meta }}</footer>
</article>
